import styled from "styled-components";

/* ============================= */
/* Main Section */
/* ============================= */
export const ProjSection = styled.section`
  padding: 60px 20px;
  text-align: center;
  color: white;
  min-height: 100vh;
  position: relative;
  overflow: hidden;

  /* Background */
  background-color: #0a0a0a;
  background: linear-gradient(135deg, #0a0a0a, #111, #001f2f);

  /* Decorative Glow (SAFE VERSION) */
  &::before {
    content: '';
    position: absolute;
    top: 20%;
    left: 50%;
    transform: translate(-50%, -50%);
    width: 800px;
    height: 400px;
    background: radial-gradient(
      circle,
      rgba(0, 255, 255, 0.15),
      transparent 70%
    );
    z-index: 0;

    /* 🔥 CRITICAL FIX */
    pointer-events: none; /* Prevents blocking clicks */
  }
`;

/* ============================= */
/* Header Area */
/* ============================= */
export const ProjHeader = styled.div`
  max-width: 800px;
  margin: 0 auto 40px auto;
  position: relative;
  z-index: 1; /* Above glow */

  h1 {
    font-size: 2.5rem;
    color: #0ff;
    text-shadow: 0 0 12px #0ff;
    margin-bottom: 15px;
  }

  p {
    color: #ccc;
    font-size: 1rem;
    line-height: 1.5;
    margin: 0;
  }
`;

/* ============================= */
/* Grid Layout */
/* ============================= */
export const ProjGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(280px, 1fr));
  gap: 30px;
  max-width: 1200px;
  margin: 0 auto;
  position: relative;
  z-index: 1; /* Above glow */
`;

/* ============================= */
/* Project Card */
/* ============================= */
export const ProjCard = styled.div`
  background: #111;
  border-radius: 15px;
  padding: 15px;
  transition: 0.3s ease;
  border: 1px solid rgba(0, 255, 255, 0.3);
  cursor: pointer;

  &:hover {
    transform: translateY(-8px);
    box-shadow: 0 0 20px #0ff;
  }
`;

/* ============================= */
/* Project Image */
/* ============================= */
export const ProjDivImg = styled.img`
  width: 100%;
  border-radius: 10px;
  margin-bottom: 15px;
  border: 2px solid #0ff;
  display: block;
`;